import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

import "./queues.css";
import "react-image-crop/dist/ReactCrop.css";
import "react-quill/dist/quill.snow.css";
import PatientDashboard from "../components/Dashborad/PatientDashboard";
import DoctorDashboard from "../components/DoctorDashboard/DoctorDashboard";
import SecretaryDashboard from "../components/SecretaryDashboard/SecretaryDashboard";

const Queues = (props) => {
  const role = localStorage.getItem("role");

  return (
    <div className="queuesContainer">
      {role ? (
        role === "doctor" ? (
          <DoctorDashboard subscriptionsList={props.subscriptionsList} />
        ) : role === "secretary" ? (
          <SecretaryDashboard />
        ) : (
          <PatientDashboard />
        )
      ) : null}


    </div>
  );
};
export default Queues;
